// Same inline geometry the legal-text popups in the footer use, so the EU documents open the same way.
export const modalStyles = {
    overlay: {
        zIndex: "100000"
    },
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        border: "1px solid grey",
        width: "calc(90%)",
        maxWidth: "1000px",
        minHeight: "200px",
        maxHeight: "90vh",
        overflowY: "auto",
    }
};

export const labelModalStyles = {
    ...modalStyles,
    content: {
        ...modalStyles.content,
        maxWidth: "640px",
    }
};
